import { ThemeZIndexesToken, ThemeZIndexLayerName } from '../../theme';

export const useThemeIndex = (token: ThemeZIndexLayerName | null) => {
  if (!token) {
    return null;
  }

  const cssTokenName: ThemeZIndexesToken = `--theme--index--layer--${token}`;
  const value = getComputedStyle(document.documentElement).getPropertyValue(cssTokenName);
  if (value) {
    return value;
  }
  return null;
};
